import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Size, Point,InfoWindow } from "react-google-maps";
import { ModelPropertiesParser } from '../../commons/modelPropertiesParser';
import { SearchBox } from "react-google-maps/lib/components/places/SearchBox";
import { Field } from 'redux-form';
import * as CardTemplates from '../../templates/card/index';


class MapView extends Component {
    constructor(props) {
        super(props);

        const defaultLoc = props.locationConfig;
        const dontUseCurrenLocation = defaultLoc && defaultLoc.dontUseCurrenLocation;

        const center = {
          lat: 12.92, lng: 77.546
        }
        if(defaultLoc && defaultLoc.defaultLocation) {
          const loc = defaultLoc.defaultLocation.split(",");
          center.lat = parseFloat(loc[0]);
          center.lng = parseFloat(loc[1]);
        }

        console.log(center)
        if(defaultLoc)
        this.state = {
          bounds: null,
          center: center,
          defaultCenter: center,
          markers: [],
          refs: {},
          places: null,
          showMarkerIndex: -1
        }
       
        if(!dontUseCurrenLocation){
                   this.getGeoLocation();
        }
      }

    getGeoLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.setState({center: { lat: position.coords.latitude,
                        lng: position.coords.longitude }});
                }
            )
        } else {
            console.log('Navigator geo location not found');
        }
    }

    onMapMounted = ref => {
        const refs = this.state.refs;
        refs.map = ref;
        this.setState({
          refs
        });
      }
    
      onBoundsChanged = () => {
          if(window.mapsBoundChange) {
              clearTimeout(window.mapsBoundChange);
          }
          window.mapsBoundChange = setTimeout(() => {
            const bounds = this.state.refs.map.getBounds();
            const center = this.state.refs.map.getCenter();
            const distance = this.getDistanceFromLatLonInKm(bounds.getNorthEast().lat(), bounds.getNorthEast().lng(), 
                            center.lat(), center.lng() );

            if(!this.previousBounds) {
                this.previousBounds = bounds;
                return;
            } 
            this.previousBounds = bounds;
            const filterValue = [];
            filterValue.push(`${center.lat()}`);
            filterValue.push(`${center.lng()}`);
            filterValue.push(`${Math.round(distance)}`);
            const filterConfig = {
                filter: {
                    targetClassProperty: this.props.config.laneEnumerator.classProperty,
                    leafType: this.props.config.laneEnumerator.type
                },
                filterIndex: 0
            };
            this.props.onFilterChange(filterConfig, filterValue);
            this.props.onFiltersApplied();
        }, 1000);

      }

      onSearchBoxMounted = ref => {
        const refs = this.state.refs;
        refs.searchBox = ref;
        this.setState({
          refs
        });
      }
      onPlacesChanged = () => {
        const places = this.state.refs.searchBox.getPlaces();
        const center = {
          lat: places[0].geometry.location.lat(),
          lng: places[0].geometry.location.lng()
        }
        this.setState({
          center,
          places
        });
      }

      onMarkerClick = (index) => {
          this.setState({ showMarkerIndex: index});
      }

      onMarkerClose = (index) => {
        this.setState({showMarkerIndex: -1});
    }


    componentWillReceiveProps(nextProps) {
         const {  value, classProperty, workflowData, laneKey, locationConfig, config: {card} } = nextProps;
      const newValue = ModelPropertiesParser('{{'+laneKey+'}}', workflowData && workflowData[0]);
      if(newValue  ){
        let newValues = newValue.split(",")
        let lat = newValues[0];
        let long = newValues[1];
        lat = parseFloat(lat)
        long = parseFloat(long)
        if(this.state.defaultCenter.lat == this.state.center.lat){
          this.setState({center: { lat: lat,
            lng: long }});
        }
      }
    }

    getMarkers(workflowData, laneKey, cardConfig, locationConfig) {
      const markerIcons = locationConfig && locationConfig.markerIcons;
      const mH = locationConfig && locationConfig.iconheight;
      const mW = locationConfig && locationConfig.iconwidth;
        const markerData = (workflowData || []).map((data, index) => {
          let url = null;
          markerIcons && markerIcons.map(m=>{
            let d = data[m.field];
            if (d === true) {
              d = JSON.stringify(d);
            }
            if(d == m.staticValue){
              url = {
                url: m.markerIcon,
                scaledSize: mH && mW?new window.google.maps.Size( parseInt(mW) ,parseInt(mH) ): new window.google.maps.Size(40, 40),
                origin: new window.google.maps.Point(0,0), 
                anchor: new window.google.maps.Point(0, 0)
            }
            }
          })
            let pos = data[laneKey];
            if(pos) {
                pos = pos.split(',');
                return {center: {lat: parseFloat(pos[0]), lng: parseFloat(pos[1])}, id: data.id, title: getCardData(cardConfig.title, data), data, url: url };
            }
            return {center: {lat: 0, long: 0}, id: data.id, title: getCardData(cardConfig.title, data), data };
        });
        return markerData;
    }

    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
        var dLon = this.deg2rad(lon2-lon1); 
        var a = 
          Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
          Math.sin(dLon/2) * Math.sin(dLon/2)
          ; 
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        var d = R * c; // Distance in km
        return d;
      }
      
      deg2rad(deg) {
        return deg * (Math.PI/180)
      }

    render() {
        const {  value, classProperty, workflowData, laneKey, locationConfig, config: {card} } = this.props;
        const markers = this.getMarkers(workflowData, laneKey, card, locationConfig);
        let tempCardConfig = card;
        tempCardConfig.config = {hasRating: false, cardTitle: card.title, cardSubtitle: card.label};
        const mapKey = locationConfig && locationConfig.key;
        if(!mapKey){
          return <div>Google Map key is not configured. Please contact admin</div>
        }
        return <div style={{ height: `${window.innerHeight - 70}px`, 
            width: '100%', 
            display: 'flex', 
            flexFlow: 'row nowrap', 
            justifyContent: 'center', 
            padding: 0 }} className="location">
            <LocationMap 
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${mapKey}&v=3.exp&libraries=geometry,drawing,places`}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ width: `100%`,marginLeft:`0` }} />}
            mapElement={<div style={{ height: `100%`, width: `100%` }} />}
            onMapMounted={this.onMapMounted}
            onBoundsChanged={this.onBoundsChanged}
            onSearchBoxMounted={this.onSearchBoxMounted}
            onPlacesChanged={this.onPlacesChanged}                
            center={this.state.center}
            panToBounds={() => {
              this.state.refs.map && this.state.refs.map.panToBounds(this.state.bounds);
            }}
            markers = {markers}
            classProperty={classProperty}
            value={value}
            markerIcon={locationConfig && locationConfig.markerIcon}
            markerHeight={locationConfig && locationConfig.iconheight}
            markerWidth={locationConfig && locationConfig.iconwidth}
            onMarkerClick={this.onMarkerClick}
            onMarkerClose={this.onMarkerClose}
            cardConfig={tempCardConfig}
            showMarkerIndex={this.state.showMarkerIndex}
            inlineActions={this.props.workflow.currentItem.inlineAction}
            workflow={this.props.workflow}
            mapType={locationConfig.mapType}
            zoom={locationConfig.zoom}
          />
          
          </div>
      }
}

const LocationMap = withScriptjs(withGoogleMap((props) => {
    const markerIcon = {
        url: props.markerIcon,
        scaledSize: props.markerHeight && props.markerWidth?new window.google.maps.Size( parseInt(props.markerWidth) ,parseInt(props.markerHeight) ): new window.google.maps.Size(40, 40),
        origin: new window.google.maps.Point(0,0), // origin
        anchor: new window.google.maps.Point(0, 0) // anchor
    }
    const config = props.cardConfig;
    const SimpleCard = CardTemplates.SIMPLECARD;
    const ImageCard = CardTemplates.IMAGECARD;
    return (
        <GoogleMap
          options={{
            mapTypeControl: false,
            scrollwheel: false
          }}
          ref={props.onMapMounted}
          defaultZoom={props.zoom ? Number(props.zoom) : 5}
          center={props.center}
          onBoundsChanged={props.onBoundsChanged}
          panToBounds={props.fitBounds}
          mapTypeId={props.mapType && props.mapType.value == 'SATELLITE' ? window.google.maps.MapTypeId.SATELLITE : window.google.maps.MapTypeId.ROADMAP}
        >
        <SearchBox
          ref={props.onSearchBoxMounted}
          bounds={props.bounds}
          controlPosition={1}
          onPlacesChanged={props.onPlacesChanged}
          options={{
            enableEventPropagation: false
          }}
        >
          <Field
              name={props.classProperty}
              component={renderInput}
              type="text"
              value={props.value}
              placeholder={props.placeholder}
          />
        </SearchBox>
        {props.markers.map((marker, i) => <Marker animation={window.google.maps.Animation.DROP} key={marker.id} 
            icon={marker.url ? marker.url : markerIcon} position={marker.center} title={marker.title} onClick={() => props.onMarkerClick(i)} >
        {props.showMarkerIndex === i && (
          <InfoWindow onCloseClick={() => props.onMarkerClose(i)}>
            {
              config.image && config.image.path?
              <ImageCard
                image={getCardData(config.image, marker.data)}
                title={getCardData(config.title, marker.data)}
                subtitle={getCardData(config.label, marker.data)}
                description={getCardData(config.description, marker.data)}
                label={getCardData(config.cardLabel, marker.data)}
                subtext1={getCardData(config.subtext1, marker.data)}
                subtext2={getCardData(config.subtext2, marker.data)}
                subtext3={getCardData(config.subtext3, marker.data)}
                subtext4={getCardData(config.subtext4, marker.data)}
                data={marker.data}
                cardConfig={props.cardConfig}
                imageCardStyle={{
                  width: '320px'
                }}
                {...props}
              />:
              <SimpleCard
                title={getCardData(config.title, marker.data)}
                subtitle={getCardData(config.label, marker.data)}
                description={getCardData(config.description, marker.data)}
                label={getCardData(config.cardLabel, marker.data)}
                subtext1={getCardData(config.subtext1, marker.data)}
                subtext2={getCardData(config.subtext2, marker.data)}
                subtext3={getCardData(config.subtext3, marker.data)}
                subtext4={getCardData(config.subtext4, marker.data)}
                data={marker.data}
                cardConfig={props.cardConfig}
                {...props}
            />
            }
          </InfoWindow>
        )}
                    </Marker>)}
      </GoogleMap>
      )
    }
  ))

  const renderInput = (props) => <Input
  type="text"
  style={{
    width: '40%',
    marginLeft: '5%',
    marginTop: '40px'
  }}
  placeholder={'Please enter the place name'}
/>;

const getCardData = (key, data) => {
    let _key = null;
    if (typeof key === 'string') {
        _key = key;
    }
    if (typeof key === 'object' && key.hasOwnProperty('path')) {
        _key = key.path;
    }
    if (_key !== null) {
        return ModelPropertiesParser(_key, data);
    }
    return 'Not Available';
}

  export default MapView;